import { Button, Stack, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomTooltip } from 'components';
import { colors } from 'constants/colors';
import { STRUCTURES_PATHS } from 'constants/paths';
import { inspectionTabMapping } from 'utils/inspectionTabMapping';
import { formatData, handleDynamicInspectionsTabChange } from 'utils/utilities';
import {
  BoxContainer,
  DateTextBox,
  IconContainer,
  StackWrapper,
  TypeInspectionLabel,
} from './PlanningBoxDate.styles';

const PlanningBoxDate = ({
  lastOrdinaryDate,
  nextOrdinaryDate,
  nextStraordinaryDate,
  lastInspectionId,
}) => {
  const params = useParams();
  const id = params.structureId;
  const navigate = useNavigate();

  return (
    <StackWrapper
      direction={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <BoxContainer>
        <IconContainer>
          <img src="/icons/calendar-blue.svg" width={40} height={40} />
        </IconContainer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            variant="h3Bold"
            sx={{
              fontSize: '0.75rem',
              color: colors.BLACK,
            }}
          >
            Date
          </Typography>
          <div style={{ display: 'flex', gap: 50 }}>
            <DateTextBox>
              <Typography
                variant="body"
                sx={{
                  fontSize: '0.75rem',
                }}
              >
                Ultima ispezione
              </Typography>

              <TypeInspectionLabel inspectionType={'Ordinaria'}>
                Ordinaria
              </TypeInspectionLabel>
              {lastOrdinaryDate ? (
                <Typography
                  variant="body"
                  sx={{
                    fontSize: '0.75rem',
                  }}
                >
                  {formatData(lastOrdinaryDate)}
                </Typography>
              ) : (
                <Typography
                  variant="body"
                  sx={{
                    fontSize: '0.75rem',
                  }}
                >
                  n.d.
                </Typography>
              )}
            </DateTextBox>

            <DateTextBox>
              <CustomTooltip
                position="top"
                btnText={
                  <>
                    <Typography
                      variant="body"
                      sx={{
                        fontSize: '0.75rem',
                        color: '#000000',
                      }}
                    >
                      Prossima ispezione
                    </Typography>
                    <TypeInspectionLabel inspectionType={'Ordinaria'}>
                      Ordinaria
                    </TypeInspectionLabel>
                    {nextOrdinaryDate ? (
                      <Typography
                        variant="body"
                        sx={{
                          fontSize: '0.75rem',
                          color: '#000000',
                        }}
                      >
                        {formatData(nextOrdinaryDate)}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body"
                        sx={{
                          fontSize: '0.75rem',
                          color: '#000000',
                        }}
                      >
                        n.d.
                      </Typography>
                    )}
                  </>
                }
                title={
                  'Data di prossima ispezione ordinaria al fine di garantire i cicli di ispezioni periodiche così come richiesto dalle Linee Guida'
                }
              />
            </DateTextBox>

            <DateTextBox>
              <CustomTooltip
                position="top"
                btnText={
                  <>
                    <Typography
                      variant="body"
                      sx={{
                        fontSize: '0.75rem',
                        color: '#000000',
                      }}
                    >
                      Prossima ispezione
                    </Typography>

                    <TypeInspectionLabel inspectionType={'Straordinaria'}>
                      Straordinaria
                    </TypeInspectionLabel>
                    {nextStraordinaryDate ? (
                      <Typography
                        variant="body"
                        sx={{
                          fontSize: '0.75rem',
                          color: '#000000',
                        }}
                      >
                        {formatData(nextStraordinaryDate)}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body"
                        sx={{
                          fontSize: '0.75rem',
                          color: '#000000',
                        }}
                      >
                        n.d.
                      </Typography>
                    )}
                  </>
                }
                title={
                  'Data di prossima ispezione straordinaria al fine di garantire i cicli di ispezioni periodiche così come richiesto dalle Linee Guida'
                }
              />
            </DateTextBox>
          </div>
        </div>
      </BoxContainer>
      <Button
        color="secondary"
        variant={'outlined'}
        disabled={lastInspectionId ? false : true}
        onClick={() =>
          handleDynamicInspectionsTabChange(
            inspectionTabMapping.L1,
            inspectionTabMapping.DatiGenerali,
            inspectionTabMapping.L1InformazioneIspezione,
            navigate,
            STRUCTURES_PATHS.STRUCTURES_LIST,
            id,
            lastInspectionId
          )
        }
      >
        {'Approfondisci'}
      </Button>
    </StackWrapper>
  );
};

export { PlanningBoxDate };

PlanningBoxDate.propTypes = {
  lastOrdinaryDate: PropTypes.object,
  nextOrdinaryDate: PropTypes.object,
  nextStraordinaryDate: PropTypes.object,
  lastInspectionId: PropTypes.number,
};
